/** Catálogo e defaults de módulos por tipo de licença. */



export const PRODUTOS_POR_LICENCA = {

  ZenGestao: ["Gestao", "Transversal", "Pdv"],

  ZenPDV: ["Pdv"],

  ZenTag: ["ZenTag"],

  ZenMobile: ["ZenMobile"],

  ZenPass: ["ZenPass"],

};



/** Inclusos no ZenGestão — não aparecem na UI e sempre vão ativos no PUT. */

export const CODIGOS_SEMPRE_ATIVOS_ZENGESTAO = new Set([
  "GESTAO_BASE",
  "MOD_CADASTROS",
  "MOD_ESTOQUE",
  "MOD_FORNECEDORES",
  "MOD_NFE",
]);



/** Contadores no ZenGestão (0 = desligado). */

export const CODIGOS_CONTADOR_ZENGESTAO = new Set([

  "ADD_PDV_ADICIONAL",

  "ADD_AUTOATENDIMENTO",

  "ADD_EMPRESA",

  "ADD_WHATSAPP",

  "ADD_INVENTARIO",

  "ADD_PREVENDA",

  "ADD_ZENPAY",

  "ADD_MULTI_ESTOQUE",

  "ADD_ORCAMENTO",

  "ADD_COMPRA",

]);



/** Inclusos no ZenPDV Desktop — 1º terminal sempre na licença base. */
export const CODIGOS_SEMPRE_ATIVOS_ZENPDV = new Set(["PDV_BASE"]);

/** Contadores no ZenPDV Desktop (PDVs além do 1º terminal). */
export const CODIGOS_CONTADOR_ZENPDV = new Set(["ADD_PDV_ADICIONAL"]);

export const CODIGOS_PADRAO = {
  ZenGestao: [...CODIGOS_SEMPRE_ATIVOS_ZENGESTAO],
  ZenPDV: [...CODIGOS_SEMPRE_ATIVOS_ZENPDV],
};



export function moduloOcultoUI(codigo, licencaTipo) {
  if (licencaTipo === "ZenGestao" && CODIGOS_SEMPRE_ATIVOS_ZENGESTAO.has(codigo)) {
    return true;
  }
  if (licencaTipo === "ZenPDV" && CODIGOS_SEMPRE_ATIVOS_ZENPDV.has(codigo)) {
    return true;
  }
  return false;
}

export function moduloApenasContador(codigo, licencaTipo) {
  if (licencaTipo === "ZenGestao") {
    return CODIGOS_CONTADOR_ZENGESTAO.has(codigo);
  }
  if (licencaTipo === "ZenPDV") {
    return CODIGOS_CONTADOR_ZENPDV.has(codigo);
  }
  return false;
}

export function nomeModuloUI(modulo, licencaTipo) {
  if (!modulo) return "";
  if (modulo.codigo === "ADD_PDV_ADICIONAL" && licencaTipo === "ZenGestao") {
    return "PDV adicional";
  }
  if (modulo.codigo === "ADD_PDV_ADICIONAL" && licencaTipo === "ZenPDV") {
    return "PDV adicional";
  }
  if (modulo.codigo === "PDV_BASE" && licencaTipo === "ZenPDV") {
    return "ZenPDV Desktop";
  }
  return modulo.nome;
}



export function filtrarModulosPorLicenca(modulos, licencaTipo) {

  const produtos = PRODUTOS_POR_LICENCA[licencaTipo] || [];

  return (modulos || []).filter((m) => {

    if (!produtos.includes(m.produto)) return false;

    if (licencaTipo === "ZenGestao" && (m.codigo === "PDV_BASE" || m.codigo === "ADD_PDV_POS")) {
      return false;
    }
    if (licencaTipo === "ZenPDV" && (m.codigo === "ADD_PDV_POS" || m.produto === "Transversal")) {
      return false;
    }

    if (moduloOcultoUI(m.codigo, licencaTipo)) return false;

    return true;

  });

}



/** Catálogo completo (inclui módulos ocultos) para PUT /licenca-modulos. */

export function catalogoCompletoPorLicenca(modulos, licencaTipo) {

  const produtos = PRODUTOS_POR_LICENCA[licencaTipo] || [];

  return (modulos || []).filter((m) => {

    if (!produtos.includes(m.produto)) return false;

    if (licencaTipo === "ZenGestao" && (m.codigo === "PDV_BASE" || m.codigo === "ADD_PDV_POS")) {
      return false;
    }
    if (licencaTipo === "ZenPDV" && (m.codigo === "ADD_PDV_POS" || m.produto === "Transversal")) {
      return false;
    }

    return true;

  });

}



export function idsFromCodigos(modulos, codigos) {

  const set = new Set(codigos);

  return modulos.filter((m) => set.has(m.codigo)).map((m) => m.id);

}



/** Módulos com stepper no ZenPDV (checkbox + quantidade). */

export const CODIGOS_COM_QUANTIDADE = new Set([

  "ADD_PDV_ADICIONAL",

  "ADD_PDV_POS",

  "ADD_EMPRESA",

]);



export function moduloUsaQuantidade(codigo, licencaTipo = "ZenPDV") {

  if (moduloApenasContador(codigo, licencaTipo)) return true;

  return CODIGOS_COM_QUANTIDADE.has(codigo);

}



export function quantidadeModuloPorCodigo({ catalogo = [], quantidades = {} } = {}, codigo) {
  const mod = (catalogo || []).find((m) => m.codigo === codigo);
  if (!mod) return 0;
  return Math.max(0, Math.trunc(Number(quantidades[mod.id]) || 0));
}

export function itemModuloId(item) {
  return item?.moduloId ?? item?.ModuloId;
}

export function itemAtivo(item) {
  return item?.ativo ?? item?.Ativo;
}

export function itemQuantidade(item) {
  return item?.quantidade ?? item?.Quantidade;
}

export function quantidadesFromItens(itens, licencaTipo = "ZenGestao") {
  const map = {};
  (itens || []).forEach((i) => {
    const moduloId = itemModuloId(i);
    if (moduloId == null || !itemAtivo(i)) return;
    const qtd = Number(itemQuantidade(i));
    if (!Number.isFinite(qtd) || qtd <= 0) return;
    map[moduloId] = Math.max(1, Math.trunc(qtd));
  });
  return map;
}

export function selectedIdsFromItens(itens, catalogo, licencaTipo) {
  return (itens || [])
    .filter((i) => itemAtivo(i))
    .filter((i) => {
      const moduloId = itemModuloId(i);
      const mod = catalogo.find((m) => m.id === moduloId);
      return mod && !moduloApenasContador(mod.codigo, licencaTipo);
    })
    .map((i) => itemModuloId(i));
}



/**

 * Snapshot completo do catálogo para PUT /licenca-modulos.

 * Desmarcados vão com ativo:false para o backend registrar cancelamento.

 */

export function montarItensModulos({

  catalogo = [],

  selectedIds = [],

  quantidades = {},

  licencaTipo = "ZenGestao",

} = {}) {

  const ativos = new Set(selectedIds);



  return (catalogo || []).map((m) => {

    if (licencaTipo === "ZenGestao" && CODIGOS_SEMPRE_ATIVOS_ZENGESTAO.has(m.codigo)) {
      return { moduloId: m.id, quantidade: 1, ativo: true };
    }

    if (licencaTipo === "ZenPDV" && CODIGOS_SEMPRE_ATIVOS_ZENPDV.has(m.codigo)) {
      return { moduloId: m.id, quantidade: 1, ativo: true };
    }



    if (moduloApenasContador(m.codigo, licencaTipo)) {

      const qtd = Math.max(0, Math.trunc(Number(quantidades[m.id]) || 0));

      return {

        moduloId: m.id,

        quantidade: qtd > 0 ? qtd : 1,

        ativo: qtd > 0,

      };

    }



    if (moduloUsaQuantidade(m.codigo, licencaTipo)) {

      const ativo = ativos.has(m.id);

      const qtd = Math.max(1, Math.trunc(Number(quantidades[m.id]) || 1));

      return { moduloId: m.id, quantidade: ativo ? qtd : 1, ativo };

    }



    const ativo = ativos.has(m.id);

    return { moduloId: m.id, quantidade: 1, ativo };

  });

}



export function formatBRL(value) {

  return Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

}



export const UNIDADE_LABEL = {

  licenca: "/licença",

  terminal: "/terminal",

  empresa: "/empresa",

  dispositivo: "/dispositivo",

  estabelecimento: "/estabelecimento",

  mes: "/mês",

};


